import {GLTFLoader} from "three/addons";
import roundPawnModel from "@assets/models/pion_cercle"
import squarePawnModel from "@assets/models/pion_carre"

export class ModelsLoader {
    static INSTANCE;

    loadingPromise;

    modelP1;
    modelP2;

    static getInstance() {
        if (!ModelsLoader.INSTANCE) ModelsLoader.INSTANCE = new ModelsLoader();

        return ModelsLoader.INSTANCE;
    }

    constructor() {
        this.loadingPromise = this.loadModels()
    }

    async loadModels() {
        const loader = new GLTFLoader();

        const player1Promise = new Promise((resolve, reject) => {
            loader.load(
                roundPawnModel,
                (gltf) => {
                    this.modelP1 = gltf;
                    resolve();
                },
                undefined,
                (error) => {
                    console.error(`Error while loading player 1 model :`, error);
                    reject(error);
                }
            );
        });

        const player2Promise = new Promise((resolve, reject) => {
            loader.load(
                squarePawnModel,
                (gltf) => {
                    this.modelP2 = gltf;
                    resolve();
                },
                undefined,
                (error) => {
                    console.error(`Error while loading player 1 model :`, error);
                    reject(error);
                }
            );
        });

        await Promise.all([player1Promise, player2Promise]);
    }

    async awaitReady() {
        await this.loadingPromise;
    }

    getModelP1() {
        return this.modelP1.scene.clone();
    }

    getModelP2() {
        return this.modelP2.scene.clone();
    }
}